import selectedEmployeeCollection from "@/data/selectedEmployeeCollection";
export function whetherEmployeeCanAccess(currentEmployeeMail) {
    return selectedEmployeeCollection.employeeDataCollection.some(employeeData => employeeData.mail === currentEmployeeMail)
}